<template>
  <div class="recall">
    <div class="recall__container">
      <Moles class="recall__moles" :count="1" background="transparent" align="right" :scale="2.25" reversed />
      <div class="recall__wrapper">
        <h2 class="recall__title">{{ title }}</h2>
        <div class="recall__content">
          <slot />
        </div>
      </div>
      <div class="recall__img"><img :src="`/img/web/${image}.webp`" alt="Imagen mujer" /></div>
    </div>
  </div>
</template>

<script>
import Moles from '@/lego/components/layout/Moles.vue';

export default {
  components: {
    Moles,
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    image: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="postcss" scoped>
.recall {
  @apply relative py-xxl px-xxs lg:py-huge;

  &__container {
    @apply container relative flex overflow-hidden rounded-md container-thin bg-brand-primary-medium lg:overflow-visible py-xl sm:pt-xxxl sm:pb-xxl lg:pt-xl lg:pb-xxl lg:px-xxxl xl:px-xxl 2xl:px-giant;
  }

  &__moles {
    @apply absolute z-0 lg:hidden -left-giant -bottom-xs;
  }

  &__wrapper {
    @apply z-0 px-xxs lg:px-0 lg:col-3-8 xl:col-3-12;
  }

  &__title {
    @apply text-center text-neutral-ultradark style-title-sm-bold mb-xl sm:mb-xxs lg:mb-sm lg:text-left;
  }

  &__content {
    @apply flex flex-col gap-xxs lg:gap-xxxs items-center m-auto text-center max-w-content;

    > * {
      @apply w-full;
    }
  }

  &__img {
    @apply absolute bottom-0 hidden lg:block lg:right-xxxl xl:right-xxl 2xl:right-giant w-[15.5rem] xl:w-[16.875rem];
  }
}
</style>
